import Vue from 'vue'
import classificators from '../../api/classificators'
import localStorageHelper from '@/helpers/localStorageHelper'
import dateMixin from '@/mixins/date'

const state = () => ({
  classificators: null
})

// getters
const getters = {
  getListOfClassificators: (state) =>
  {
    if (!state.classificators)
    {
      return null
    }
    try
    {
      if (state.classificators)
      {
        return state.classificators
      }
    }
    catch (e)
    {
      console.log('List of classificators data get failed', e)
      return null
    }
  }
}

// actions
const actions = {
  updateClassificators({state, commit}, details)
  {
    commit('updateClassificators', details)
  },
  fetchClassificators({state, commit})
  {
    try
    {
      if (!state.classificators)
      {
        const today = dateMixin.methods.getToday()
        const lsClassificators = localStorageHelper.getJson('classificators')
        const lsClassificatorsUpdated = localStorageHelper.get('classificatorsUpdated')
        if (lsClassificators && lsClassificatorsUpdated && lsClassificatorsUpdated === today)
        {
          // console.log('Using classificators from lsClassificators...')
          // console.log(lsClassificators)
          commit('updateClassificators', lsClassificators)
        } else {
          // console.log('Send request to BE for classificators...')
          classificators.get().then(response =>
            {
              commit('updateClassificators', response)
              // console.log('saving classificators to lsClassificators!...', response)
              localStorageHelper.setAsJson('classificators', response)
              localStorageHelper.set('classificatorsUpdated', today)
            }
          )
        }
      }
    }
    catch (e)
    {
      console.log('Failed load classificators', e)
    }
  }
}

// mutations
const mutations = {
  updateClassificators(state, classificatorsData)
  {
    Vue.set(state, 'classificators', classificatorsData)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
